import BulkEditTable from './bulkEditTable.container';

export default BulkEditTable